(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("userful-chronos-common-store", [], factory);
	else if(typeof exports === 'object')
		exports["userful-chronos-common-store"] = factory();
	else
		root["userful-chronos-common-store"] = factory();
})(this, () => {
return 